import { Box, BoxProps, ColorOptions, Icon, Spacer, Text, TextNew, TextProps } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { Clipboard, ScrollView, TextStyle, ViewStyle } from 'react-native'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { TableComponent } from '../../comps/TableComponent'
import { dateFormatter, DateFormatTypes } from '../../util/util'
type TitlesType = {
  [key: string]: string
}

const dataTitles: TitlesType = {
  id: 'ID',
  jioLinkId: 'Jio Link ID',
  url: 'Payment Link',
  createdAt: 'Created Date',
  paidAt: 'Modified On Date',
  status: 'Status',
  amount: 'Amount',
  merchantLinkId: 'Merchant Link ID',
  linkExpiryAt: 'Link Expires On',
  invoice: 'Invoice Number',
  description: 'Payment For',
  pushSmsTo: 'Mobile Number',
  pushEmailTo: 'Email',
}

interface DetailsViewProps {
  data: any
  refresh?: (number: number) => void
}

const DetailsView: FC<DetailsViewProps> = (props: DetailsViewProps) => {
  const { data, refresh } = props
  const [showDetails, setShowDetails] = useState(false)
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    setCopied(false) //children function of interest
  }, [refresh])

  const getBackgroundColor = (value: string) => {
    type colorType = {
      [key: string]: any
    }
    const getColor: colorType = {
      Paid: styles.bgPaid,
      Issued: styles.bgIssued,
      Cancelled: styles.bgCancelled,
      Expired: styles.bgExpired,
      SUCCESS: styles.SUCCESS,
      INITIATED: styles.INITIATED,
      FAILURE: styles.bgExpired,
      FAILED: styles.bgExpired,
    }

    return getColor[value] ?? styles.bgDefault
  }

  const getTextColor = (value: string) => {
    type colorType = {
      [key: string]: string
    }
    const getColor: colorType = {
      PAID: 'GREEN_C',
      ISSUED: 'BLUE_C',
      CANCELLED: 'ORANGE_C',
      EXPIRED: 'RED_C',
      SUCCESS: 'GREEN_C',
      INITIATED: 'BLUE_C',
      FAILURE: 'RED_C',
      FAILED: 'RED_C',
    }
    return (getColor[value] as ColorOptions) ?? 'BLACK_21'
  }

  const getTextOpacity = (value: string) => {
    type opacityType = {
      [key: string]: number
    }
    const getOpacity: opacityType = {
      Cancelled: 0.3,
      Expired: 0.3,
    }
    return getOpacity[value] ?? 1
  }

  const getStatusText = (status: string) => {
    type stringType = {
      [key: string]: string
    }
    const getText: stringType = {
      PAID: data?.paidAt && `Paid on ${data?.paidAt}`,
      CANCELLED: data?.createdAt && `Created at ${data?.createdAt}`,
    }
    return getText[status] ?? ''
  }

  const containerStyle = (value: string) => {
    if (value === 'url') {
      return { alignItems: 'center', flexDirection: 'row' } as BoxProps
    }
    return {} as BoxProps
  }

  const onCopy = () => {
    setCopied(true)
    Clipboard.setString(data?.url)
  }

  const getContainer = (value: string) => {
    return value === 'url' ? styles.urlContainer : styles.container
  }

  const renderItem = ({ item, index }: { item: any; index: number }) => {
    return (
      <Box
        flexDirection="row"
        alignItems={'center'}
        borderBottomWidth={1}
        borderBottomColor={'DISABLED_GREY'}
        padding={16}
        width={328}>
        <Box flexDirection="column" key={`status${index}`}>
          <Text {...styles.listitemTitle} title={item?.transactionRefNo} />
          <Spacer direction="vertical" size={4} />
          <Text
            {...styles.listitemValue}
            title={`Attempted At: ${dateFormatter(item?.createdAt, DateFormatTypes.DD_MMM_YYYY_HH_MM_AMPM)}`}
          />
        </Box>
        <Spacer direction={'horizontal'} size={16} />
        <Box {...getBackgroundColor(item?.status)}>
          <TextNew
            type="body12"
            color={getTextColor(item?.status)}
            opacity={getTextOpacity(item?.status)}
            fontFamily={'jiotype-medium'}>
            {item?.status}
          </TextNew>
        </Box>
      </Box>
    )
  }

  const detailsView = Object.keys(data).map((item) => {
    return item === 'transactions' && data?.transactions?.length > 0 ? (
      <Box {...styles.txnsContainer}>
        <Box minWidth={200} marginTop={8} alignSelf={'flex-start'}>
          <TextNew textAlign="left" type="body14" color="PRIMARY_GREY" fontFamily={'jiotype-medium'}>
            Transactions
          </TextNew>
        </Box>
        <Box flexDirection={'column'} width={'100%'}>
          <Box
            {...styles.showHideContainer}
            testID="show-payment-link-detail"
            onPress={() => setShowDetails(!showDetails)}>
            <Text {...styles.showHideText} value={`${showDetails ? 'Hide' : 'Show'} Transactions`} />
            <Spacer direction="horizontal" size={8} />
            <Icon id={showDetails ? 'ARROW_UP' : 'ARROW_DOWN'} size={12} color="PRIMARY" />
          </Box>
          {showDetails && (
            <Box {...styles.transtactions}>
              <TableComponent
                value={''} //Routes value
                canFetchMore={false}
                hide={false}
                isCustom={true}
                ListContent={data?.transactions ?? []}
                RenderCustomElement={renderItem}
              />
            </Box>
          )}
        </Box>
      </Box>
    ) : (
      <ModBox show={data[item] !== ''} {...getContainer(item)}>
        <ModBox show={data[item] !== ''} minWidth={200}>
          <TextNew type="body14" color="PRIMARY_GREY" fontFamily={'jiotype-medium'}>
            {dataTitles[item]}
          </TextNew>
        </ModBox>
        <Spacer size={4} direction="horizontal" />
        <Box {...containerStyle(item)}>
          <ModBox show={data[item] !== ''} {...getBackgroundColor(data[item])} maxWidth={350} flexWrap="wrap">
            <TextNew
              type="body14"
              flexShrink={1}
              color={getTextColor(data[item])}
              opacity={getTextOpacity(data?.status)}
              numberOfLines={4}
              fontFamily={'jiotype-medium'}>
              {data[item] ?? 'NA'}
            </TextNew>
          </ModBox>
          {(data[item] === 'PAID' || data[item] === 'CANCELLED') && (
            <Box paddingVertical={8}>
              <TextNew
                type="body12"
                color="LIGHT_BLACK"
                opacity={getTextOpacity(data?.status)}
                fontFamily={'jiotype-medium'}>
                {getStatusText(data[item])}
              </TextNew>
            </Box>
          )}
          {item === 'url' && (
            <>
              <Spacer direction="horizontal" size={8} />
              <Box
                testID="copyBtn"
                backgroundColor={copied ? 'GREEN' : ('BLACK_1A' as ColorOptions)}
                underlayColor={'BLACK_1A' as ColorOptions}
                paddingVertical={4}
                paddingHorizontal={8}
                borderRadius={4}
                onPress={onCopy}>
                <TextNew type="body12" color={copied ? 'WHITE' : 'LIGHT_BLACK'} fontFamily={'jiotype-medium'}>
                  {copied ? 'Copied' : 'Copy'}
                </TextNew>
              </Box>
            </>
          )}
        </Box>
      </ModBox>
    )
  })
  return (
    <ScrollView style={styles.scollContainer}>
      <Box paddingHorizontal={24} marginRight={100}>
        {detailsView}
      </Box>
    </ScrollView>
  )
}

export { DetailsView }

const styles = {
  bgPaid: {
    backgroundColor: 'GREEN_BG_C',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  },
  bgIssued: {
    backgroundColor: 'BLUE_BG_C',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  },
  bgCancelled: {
    backgroundColor: 'ORANGE_BG_C',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  },
  bgExpired: {
    backgroundColor: 'RED_BG_C',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  },
  EXPIRED: {
    backgroundColor: 'RED_C',
    color: 'RED_TEXT',
    textAlign: 'center',
    flex: 1,
    borderRadius: 2,
  } as TextStyle,
  SUCCESS: {
    backgroundColor: '#11C13A1A',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  } as TextStyle,
  PAID: {
    backgroundColor: '#11C13A1A',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  } as TextStyle,
  INITIATED: {
    backgroundColor: '#1386B01A',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  } as ViewStyle,
  bgDefault: { backgroundColor: 'WHITE' },
  urlContainer: { flexDirection: 'row', paddingVertical: 8, alignItems: 'center' } as BoxProps,
  txnsContainer: { flexDirection: 'row', alignItems: 'center', paddingVertical: 8 } as BoxProps,
  container: { flexDirection: 'row', paddingVertical: 8 } as BoxProps,
  transtactions: {
    width: 328,
    borderWidth: 1,
    borderColor: 'DISABLED_GREY',
  } as BoxProps,
  showHideContainer: {
    underlayColor: 'TRANSPARENT',
    marginVertical: 8,
    flexDirection: 'row',
    alignItems: 'center',
    width: 328,
  } as BoxProps,
  showHideText: {
    fontFamily: 'jiotype-medium',
    fontSize: 14,
    color: 'PRIMARY',
  } as TextProps,
  listitemTitle: {
    fontFamily: 'jiotype-medium',
    fontSize: 12,
    color: 'BLACK_21',
  } as TextProps,
  listitemValue: {
    fontFamily: 'jiotype-medium',
    fontSize: 12,
    color: 'LIGHT_BLACK',
  } as TextProps,
  scollContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
  } as ViewStyle,
}
